const favoriteBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="8 0.25 6 5.99845041 0 5.99845041 4.89 9.82941632 2.968 15.75 8 12.0911674 13.032 15.75 11.11 9.82941632 16 5.99845041 10 5.99845041"/></svg>',
};

export { favoriteBold as default };
